import { render, staticRenderFns } from "./PdfUploadDialog.vue?vue&type=template&id=4c540dce&scoped=true"
import script from "./PdfUploadDialog.vue?vue&type=script&lang=js"
export * from "./PdfUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./PdfUploadDialog.vue?vue&type=style&index=0&id=4c540dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c540dce",
  null
  
)

export default component.exports